<template>
  <form v-if="details" ref="paymentForm" :action="parseInt(details.testMode, 10) === 100 ? 'https://secure-test.worldpay.com/wcc/purchase' : 'https://secure.worldpay.com/wcc/purchase'" method=POST>
    <input type="hidden" name="testMode" :value="details.testMode">
    <input type="hidden" name="instId" :value="details.instId">
    <input type="hidden" name="amount" :value="details.amount">
    <input type="hidden" name="currency" :value="details.currency">
    <input type="hidden" name="cartId" :value="details.cartId">

    <input type="hidden" name="name" :value="details.name">
    <input type="hidden" name="email" :value="details.email">
    <input type="hidden" name="address1" :value="details.address1">
    <input type="hidden" name="postcode" :value="details.postcode">

    <input type="hidden" name="callbackPW" :value="details.callbackPW">
    <input type="hidden" name="accId1" :value="details.accId1">
    <input type="hidden" name="M_invoice_ids[]" :value="details.M_invoice_ids">

    <input type="hidden" name="signature" :value="details.signature">
  </form>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default: null,
    },
  },

  watch: {
    details(new_value) {
      if (new_value !== null) {
        this.$nextTick(function () {
          this.$refs.paymentForm.submit();
        });
      }
    }
  }
};
</script>
